// Generic addToHistory
export const addToHistory = (
  text: string,
  setHistory: React.Dispatch<React.SetStateAction<string[]>>,
  setIndex: React.Dispatch<React.SetStateAction<number>>
) => {
  setHistory((prev) => {
    const newHistory = [...prev];
    if (newHistory.length === 0 || newHistory[newHistory.length - 1] !== text) {
      newHistory.push(text);
    }
    setIndex(newHistory.length - 1);
    return newHistory;
  });
};

// Generic handleHistoryNavigation
export const handleHistoryNavigation = (
  direction: "back" | "forward",
  history: string[],
  currentIndex: number,
  setIndex: React.Dispatch<React.SetStateAction<number>>,
  formikField: string,
  formik: any
) => {
  if (direction === "back" && currentIndex > 0) {
    const newIndex = currentIndex - 1;
    setIndex(newIndex);
    formik.setFieldValue(formikField, history[newIndex]);
  } else if (direction === "forward" && currentIndex < history.length - 1) {
    const newIndex = currentIndex + 1;
    setIndex(newIndex);
    formik.setFieldValue(formikField, history[newIndex]);
  }
};
